import { createBrowserRouter } from "react-router-dom";
import React, { Suspense } from "react";

import { csobRoutes, globalRoutes, guestRoutes, publicRoutes, userRoutes } from "./routes";

import { GlobalLayout } from "@layouts";
import { Loader } from "@components/common";

// TODO: Implement lazy loading for routes?

export const router = createBrowserRouter([
  {
    element: (
      <Suspense fallback={<Loader />}>
        <GlobalLayout />
      </Suspense>
    ),
    path: "/",
    children: [...globalRoutes, ...publicRoutes, ...guestRoutes, ...csobRoutes, ...userRoutes],
  },
]);
